export default "__VITE_ASSET__DKVOFKCo__"